import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ExpandableSection/expandable-section';
import { css } from '@patternfly/react-styles';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
export var ExpandableSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ExpandableSection, _React$Component);

  function ExpandableSection(props) {
    var _this;

    _classCallCheck(this, ExpandableSection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExpandableSection).call(this, props));
    _this.state = {
      isExpanded: props.isExpanded
    };
    return _this;
  }

  _createClass(ExpandableSection, [{
    key: "calculateToggleText",
    value: function calculateToggleText(toggleText, toggleTextExpanded, toggleTextCollapsed, propOrStateIsExpanded) {
      if (propOrStateIsExpanded && toggleTextExpanded !== '') {
        return toggleTextExpanded;
      }

      if (!propOrStateIsExpanded && toggleTextCollapsed !== '') {
        return toggleTextCollapsed;
      }

      return toggleText;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          onToggleProp = _a.onToggle,
          isActive = _a.isActive,
          className = _a.className,
          toggleText = _a.toggleText,
          toggleTextExpanded = _a.toggleTextExpanded,
          toggleTextCollapsed = _a.toggleTextCollapsed,
          children = _a.children,
          isExpanded = _a.isExpanded,
          props = __rest(_a, ["onToggle", "isActive", "className", "toggleText", "toggleTextExpanded", "toggleTextCollapsed", "children", "isExpanded"]);

      var onToggle = onToggleProp;
      var propOrStateIsExpanded = isExpanded; // uncontrolled

      if (isExpanded === undefined) {
        propOrStateIsExpanded = this.state.isExpanded;

        onToggle = function onToggle() {
          onToggleProp();

          _this2.setState(function (prevState) {
            return {
              isExpanded: !prevState.isExpanded
            };
          });
        };
      }

      var computedToggleText = this.calculateToggleText(toggleText, toggleTextExpanded, toggleTextCollapsed, propOrStateIsExpanded);
      return React.createElement("div", Object.assign({}, props, {
        className: css(styles.expandableSection, propOrStateIsExpanded && styles.modifiers.expanded, isActive && styles.modifiers.active, className)
      }), React.createElement("button", {
        className: css(styles.expandableSectionToggle),
        type: "button",
        "aria-expanded": propOrStateIsExpanded,
        onClick: onToggle
      }, React.createElement("span", {
        className: css(styles.expandableSectionToggleIcon)
      }, React.createElement(AngleRightIcon, {
        "aria-hidden": true
      })), React.createElement("span", {
        className: css(styles.expandableSectionToggleText)
      }, computedToggleText)), React.createElement("div", {
        className: css(styles.expandableSectionContent),
        hidden: !propOrStateIsExpanded
      }, children));
    }
  }]);

  return ExpandableSection;
}(React.Component);
ExpandableSection.defaultProps = {
  className: '',
  toggleText: '',
  toggleTextExpanded: '',
  toggleTextCollapsed: '',
  onToggle: function onToggle() {
    return undefined;
  },
  isActive: false
};